import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { PortalProps } from "./types";
import { getDefaultContainer } from "./utils";

export const Portal = ({
  children,
  getContainer = getDefaultContainer,
}: PortalProps) => {
  const [container, setContainer] = useState<Element | null | undefined>(null);

  useEffect(() => {
    setContainer(getContainer());
  }, [getContainer]);

  if (!container) {
    return null;
  }

  return createPortal(children, container);
};
